// extracted by mini-css-extract-plugin
export default {"container":"style_container__rS3HS","backgroundImg":"style_backgroundImg__aidUp","titleBox":"style_titleBox__tjv8I"};